var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-header-trigger"},[_c('i',{class:_vm.app.menuStatus ? 'el-icon-s-fold' : 'el-icon-s-unfold',staticStyle:{"cursor":"pointer"},on:{"click":_vm.setMenuStatus}})])
}
var staticRenderFns = []

export { render, staticRenderFns }